module.exports = __webpack_public_path__ + "static/media/frame51.6fc9d198.svg";